import React from "react";
import Main from "./components/main";
import Footer from "./components/footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/index.css";

function App() {
  return (
    <>
      <Main />
      <Footer />
    </>
  );
}

export default App;
